import { render, staticRenderFns } from "./displayDetailUser.vue?vue&type=template&id=3a78cacb&"
import script from "./displayDetailUser.vue?vue&type=script&lang=js&"
export * from "./displayDetailUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports